<template>
    <o-form-group
        :id="this_id"
        :form-state="formState"
        :label="label"
        :message="errorMessages"
        :nolabel="nolabel"
        :type="{ 'is-danger': hasError }"
    >
        <o-file-upload
            :id="this_id"
            :class="input_class"
            :file="value"
            :form-state="formState"
            v-bind="$attrs"
            @change="on_change"
            v-on="inputListeners"
        >
        </o-file-upload>
        <o-file-preview
            v-if="showPreview"
            :disable-download="disableDownload"
            :file="value"
            :token="token"
        />
    </o-form-group>
</template>

<script>
import FormComponentMixin from "../../../mixins/form_component_mixin.js";
import OFormGroup from "../OFormGroup.vue";
import OFilePreview from "../../../filesystem/OFilePreview.vue";
import OFileUpload from "../../../filesystem/OFileUpload.vue";

export default {
    name: "OFileInput",
    components: { OFormGroup, OFilePreview, OFileUpload },
    mixins: [FormComponentMixin],
    props: {
        showPreview: { type: Boolean, default: false },
        token: { type: String, default: null },
        disableDownload: { type: Boolean, default: true },
    },
};
</script>

<style scoped></style>
